import api from '@/services/api'

export default {
  methods: {
    async getLeaks() {
      try {
        this.filter = Object.assign(this.filter, {
          idCompany: this.companyId,
        })
        delete this.filter['startDate']
        delete this.filter['endDate']
        const { data } = await api.getLeakLoki(this.filter)
        this.acordeon.forEach((el) => {
          if (el.origin === 'leaks') {
            el.table['items'] = data
            el.table['items'].content =
              data.content?.map((mp) => {
                return {
                  ...mp,
                  route: 'leaks',
                  buttons: ['save'],
                }
              }) || []
            el.table['rows'] = data.totalElements
          }
        })
      } catch (error) {
        this.errorCatch(error)
      }
    },
  },
}
